module.exports = __webpack_public_path__ + "media/src/images/ad2-19d5bb6a281ca0edf0cde6b8a4cf8aca.jpg";